import { WebsiteComponentRegistry } from '@adornis/web-editor/registry.js';
import type {
  WebsiteComponentDefinition,
  WebsiteComponentRenderContext,
} from '@adornis/web-editor/types.js';
import { html } from 'lit';

const componentContent = (context: WebsiteComponentRenderContext) => context.content;

const definitions: readonly WebsiteComponentDefinition[] = [
  {
    type: 'viva-site',
    label: 'Viva Porta Website',
    category: 'Struktur',
    version: 1,
    allowedChildren: ['viva-locale'],
    render: context => html`<div class="vp-builder-site" data-viva-builder-site>${componentContent(context)}</div>`,
  },
  {
    type: 'viva-locale',
    label: 'Sprache',
    category: 'Struktur',
    version: 1,
    allowedParents: ['viva-site'],
    allowedChildren: ['viva-page'],
    render: context => html`<div class="vp-builder-locale" data-locale=${String(context.attrs.props.locale ?? '')}>${componentContent(context)}</div>`,
  },
  {
    type: 'viva-page',
    label: 'Seite',
    category: 'Struktur',
    version: 1,
    allowedParents: ['viva-locale'],
    allowedChildren: [],
    render: context => html`<section class="vp-builder-page" data-page-key=${String(context.attrs.props.pageKey ?? '')}>${componentContent(context)}</section>`,
  },
  {
    type: 'viva-text',
    label: 'Text',
    category: 'Inhalt',
    version: 1,
    render: context => html`<div class="vp-builder-text">${componentContent(context)}</div>`,
  },
];

export const vivaWebsiteRegistry = new WebsiteComponentRegistry(definitions);
